import AUDebtorDetails from "modules/addons/components/digital-onboarding/PPSRRegistration/forms/DebtorDetails/AUDebtorDetails";
import NZDebtorDetails from "modules/addons/components/digital-onboarding/PPSRRegistration/forms/DebtorDetails/NZDebtorDetails";

export { AUDebtorDetails };
export { NZDebtorDetails };
